/**
 * RESPONSIBILITY: the paths THIS SITE serves, as opposed to the framework's.
 *
 * The framework owns `/api/sections`, `/api/auth` and the rest; it does not own the
 * contact form, and it should not know one exists. Named separately from
 * FRAMEWORK_ROUTES so which is which is never a guess.
 */
export const APP_ROUTES = {
  contact: '/api/contact',
  /** Admin only. The contact messages, newest first, with their notes. */
  contactRequests: '/api/contact/requests',
  /** Admin only. `{ done }` archives a request or puts it back in the queue. */
  contactHandled: (id: number) => `/api/contact/requests/${id}/handled`,
  /** Admin only. `{ note }` replaces the note on a request. */
  contactNote: (id: number) => `/api/contact/requests/${id}/note`,
  prayer: '/api/prayer',
  /** Admin only. Marks one request dealt with. */
  prayerHandled: (id: number) => `/api/prayer/${id}/handled`,
  youtubeSermons: '/api/youtube/sermons',
  bulletins: '/api/bulletin',
  bulletinPdf: (id: string, version: string) => `/api/bulletin/${id}.pdf?v=${version}`,
} as const;
